import { getInboxPaginated } from 'wisestep-api';
import { WsPagination } from 'wisestep-base';

import { handleFilterAndPageType, singleDataHandleType } from '../helper';

type InboxPaginationProps = {
  singleDataHandle: singleDataHandleType;
  onMailItemClick: (email) => void;
  setSingleDataHandle: (data: singleDataHandleType) => void;
  setHandleFilterAndPage: (data: handleFilterAndPageType) => void;
  handleFilterAndPage: handleFilterAndPageType;
};
export const InboxPagination = ({
  singleDataHandle,
  onMailItemClick,
  setSingleDataHandle,
  setHandleFilterAndPage,
  handleFilterAndPage,
}: InboxPaginationProps) =>
  singleDataHandle.inboxData ? (
    <WsPagination
      count={Math.ceil(singleDataHandle.inboxData?.totalCount / 20)}
      onChange={async (_, value) => {
        const res = await getInboxPaginated(
          singleDataHandle.configuredAccounts[0].recruiterEmail,
          value,
          handleFilterAndPage.filter.seen
        );
        if (res.data) {
          onMailItemClick(res.data.records[0]);
          setSingleDataHandle({
            ...singleDataHandle,
            inboxData: res.data,
          });
        }

        setHandleFilterAndPage({ ...handleFilterAndPage, page: value + 1 });
      }}
      itemsPerPage={20}
      pageNumber={handleFilterAndPage.page + 1}
      defaultPage={handleFilterAndPage.page}
      isPageCount={false}
      type="Mails"
      totalCount={singleDataHandle.inboxData?.totalCount}
    />
  ) : (
    <></>
  );
